import React from 'react';
import FavoriteIcon from 'core/modules/FavoriteIcon/FavoriteIcon';
import MerchantRebateV2 from 'core/modules/MerchantRebateV2/MerchantRebateV2';
import ExtraRewardsPill from 'core/modules/ExtraRewardsPill/ExtraRewardsPill';
import {
  addPeriodAfterOfferRolloverCopy,
} from 'core/utils/apis/responseParsers/commonParsers/addPeriodAfterOfferRolloverCopy';
import dayjs from 'core/utils/dayjs';

import './OfferContent.scss';

function OfferContent({ dataItem }) {
  const {
    assets: { rolloverCopy },
    merchant: {
      name,
      id,
      rebate,
      logoUrls: {
        _120x60,
      },
    },
    couponCode,
    disclaimer,
    isOngoing,
    stopDatetime,
  } = dataItem;

  const rolloverCopyFormatted = addPeriodAfterOfferRolloverCopy(rolloverCopy);
  const expiresDate = dayjs.parseZone(stopDatetime).format('MMM DD, YYYY');

  return (
    <div className="mn_offerContent">
      <div className="mn_logoWrap">
        <div className="mn_logo">
          <img src={_120x60} alt={name} />
        </div>
      </div>
      <FavoriteIcon merchantId={id} merchantName={name} />
      <ExtraRewardsPill rebate={rebate} />
      <MerchantRebateV2 {...rebate} hideRebatePrefix hideElevationCurrency />
      <div className="mn_offerInfoWrap">
        <div
          className="mn_rolloverCopy"
          dangerouslySetInnerHTML={{ __html: rolloverCopyFormatted }}
        />
        <span className="mn_expire" data-test="merchant-offer-expire">
          {isOngoing ? <> Ongoing</> : <> Valid through {expiresDate}</>}
        </span>
        {couponCode &&
          <div className="mn_couponCode" data-test="featured-offer-502x272-coupon-code">
            <span className="mn_codeContainer">
              {rolloverCopy && <span className="mn_codeBar" />}
              <span className="mn_codeLabel">Use code: </span><span className="mn_code">{couponCode}</span>
            </span>
          </div>
        }
        {disclaimer &&
          <div className="mn_disclaimer" data-test="featured-offer-502x272-disclaimer">
            <span dangerouslySetInnerHTML={{ __html: disclaimer }} />
          </div>
        }
      </div>
    </div>
  );
}

export default OfferContent;
